import React from "react";

import MainList from "components/MainList";

import getColumns from "./columns";
import { useIssueKinds } from "context/providers/issue_kinds";

const IssuesList = () => {

  const { issue_kind_options } = useIssueKinds();

  const columns_data = getColumns(
    issue_kind_options
  );

  return (
    <MainList
      columns={columns_data}
      query_name="billing_summary_issues"
      query_path={`/billing_summaries/not_billed_issues`}
      navigation_path="/issues"
      query_context="index"
      default_sort="created_at__desc"
      col_xl={6}
      col_lg={6}
      col_md={12}
      col_xs={24}
    />
  );
};

export default IssuesList;
